var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9046C0 4.88216 4.88188 3.24249e-05 10.9049 3.24249e-05C16.9267 3.24249e-05 21.8085 4.88216 21.8085 10.9046C21.8085 16.9269 16.9267 21.809 10.9049 21.809C4.88188 21.809 0 16.9269 0 10.9046Z",
    fill: "#E5510A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6916 8.87557C7.6916 9.62346 7.33083 10.2299 6.88691 10.2299C6.44426 10.2299 6.0835 9.62346 6.0835 8.87557C6.0835 8.12768 6.44426 7.52116 6.88691 7.52116C7.33083 7.52116 7.6916 8.12768 7.6916 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7255 8.87557C15.7255 9.62346 15.366 10.2299 14.9221 10.2299C14.4782 10.2299 14.1187 9.62346 14.1187 8.87557C14.1187 8.12768 14.4782 7.52116 14.9221 7.52116C15.366 7.52116 15.7255 8.12768 15.7255 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15239 6.99092L8.42062 7.72205L5.98096 5.28226L6.71273 4.55126L9.15239 6.99092Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3882 7.72205L12.6577 6.99092L15.0974 4.55126L15.8279 5.28226L13.3882 7.72205Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.4995C8 12.4995 13 10.4995 15 16.4998",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized0);
export default __webpack_public_path__ + "static/media/sylized_0.8efabe71198c2f5b69409eaae2179ac7.svg";
export { ForwardRef as ReactComponent };